import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const maxRate = 5;
const pptPerRatePoint = 100 / maxRate;
const EMPTY_OBJECT = {};

export default class Rating extends PureComponent {
  static propTypes = {
    reviewStats: PropTypes.shape({
      averageRate: PropTypes.number,
      count: PropTypes.number,
    }),
    active: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,
    black: PropTypes.bool,
    progressBar: PropTypes.bool,
    onChange: PropTypes.func,
    withoutTitle: PropTypes.bool,
  };

  componentDidMount() {
    if (this.props.active) {
      this.ratingRef.current.addEventListener('touchstart', this.updateActiveRating, { capture: true });
      this.ratingRef.current.addEventListener('click', this.updateActiveRating);
      this.ratingRef.current.addEventListener('mousemove', this.updateActiveHover);
      this.ratingRef.current.addEventListener('mouseout', this.updateActiveHover);
    }
  }

  componentWillUnmount() {
    this.ratingRef.current.removeEventListener('touchstart', this.updateActiveRating, { capture: true });
    this.ratingRef.current.removeEventListener('click', this.updateActiveRating);
    this.ratingRef.current.removeEventListener('mousemove', this.updateActiveHover);
    this.ratingRef.current.removeEventListener('mouseout', this.updateActiveHover);
  }

  ratingRef = React.createRef();

  activeRatingRef = React.createRef();

  updateActiveHover = (event) => {
    const currentRating = this.props.reviewStats.averageRate;
    const ratingWidth = this.ratingRef.current.clientWidth;

    const ratingHover = event.type === 'mouseout'
      ? currentRating
      : Math.ceil((event.offsetX || event.layerX) / ratingWidth * 5);

    const activeRatingWidth = `${ratingHover * pptPerRatePoint}%`;

    this.activeRatingRef.current.style.width = activeRatingWidth;
  }

  updateActiveRating = (event) => {
    event.preventDefault();
    const boundingRect = this.ratingRef.current.getBoundingClientRect();

    const touchOffsetX = event.type === 'touchstart' &&
      event.targetTouches[0].clientX - boundingRect.left;

    const ratingWidth = this.ratingRef.current.clientWidth;
    const rating = Math.ceil((event.offsetX || event.layerX || touchOffsetX) / ratingWidth * 5);
    this.props.onChange(rating);
  }

  getRatingWidthStyleProp() {
    const { reviewStats } = this.props;

    if (!reviewStats) {
      return EMPTY_OBJECT;
    }

    const ratingWidth = `${reviewStats.averageRate * pptPerRatePoint}%`;
    if (this.lastRatingWidth !== ratingWidth) {
      this.lastRatingWidth = ratingWidth;
      this.lastRatingWidthStyleProp = { width: ratingWidth };
    }

    return this.lastRatingWidthStyleProp;
  }

  renderTitle = () => {
    const {
      withoutTitle,
      black,
      reviewStats,
    } = this.props;

    if (withoutTitle) {
      return null;
    }

    return black
      ? `${reviewStats.averageRate} star reviews`
      : `Reviews ${Number(reviewStats.averageRate).toFixed(1)} of ${maxRate}`;
  };

  render() {
    const {
      reviewStats,
      medium,
      large,
      black,
      progressBar,
    } = this.props;

    if (!reviewStats) {
      return null;
    }

    return (
      reviewStats && (
        <div
          className={
          classNames(
            'gn-rating',
            { 'gn-rating--medium': medium,
              'gn-rating--large': large,
              'gn-rating--black': black,
              'gn-rating--progressBar': progressBar }
          )}
          itemProp="reviewRating"
          itemScope=""
          itemType="http://schema.org/Rating"
        >
          <span className="gn-rating__inactiveLayer" ref={this.ratingRef}>
            <meta itemProp="ratingValue" content={reviewStats.averageRate} />
            <span
              className="gn-rating__activeLayer"
              style={this.getRatingWidthStyleProp()}
              title={this.renderTitle()}
              ref={this.activeRatingRef}
            />
          </span>
          {typeof reviewStats.count !== 'undefined' &&
            <span className="gn-rating__voteCount gn-content__paragraph--small">({reviewStats.count})</span>}
        </div>
      )
    );
  }
}
